/* WhatsApp flotante — custom element. Sin dependencias. */

class WhatsappFloat extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-wa-dialog]');
    this.launcher = this.querySelector('[data-wa-launcher]');
    this.tooltip = this.querySelector('[data-wa-tooltip]');
    this.statusEl = this.querySelector('[data-wa-status]');

    this.launcher?.addEventListener('click', () => this.open());
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog?.addEventListener('close', () => this.unlockScroll());

    this.querySelectorAll('[data-wa-close]').forEach((node) => {
      node.addEventListener('click', () => this.close());
    });

    this.querySelectorAll('[data-wa-agent]').forEach((node) => {
      node.addEventListener('click', (event) => this.trackAgent(event.currentTarget));
    });

    this.querySelector('[data-wa-tip-close]')?.addEventListener('click', () => {
      this.hideTooltip(true);
    });

    this.renderStatus();
    this.initTooltip();
    this.initDesignMode();
  }

  disconnectedCallback() {
    clearTimeout(this.tooltipTimer);
    clearInterval(this.statusTimer);
    this.unlockScroll();
  }

  /* ---------- Modal ---------- */

  open() {
    if (!this.dialog) return;
    this.hideTooltip(true);

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    this.renderStatus();
    document.documentElement.classList.add('wa-modal-open');
  }

  close() {
    if (!this.dialog) return;

    if (typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }

    this.unlockScroll();
    this.launcher?.focus();
  }

  unlockScroll() {
    document.documentElement.classList.remove('wa-modal-open');
  }

  /* ---------- Burbuja ---------- */

  initTooltip() {
    if (!this.tooltip) return;

    const days = parseInt(this.dataset.tooltipDays || '0', 10);
    const last = Number(this.readStorage() || 0);

    if (days > 0 && last && Date.now() - last < days * 86400000) return;

    const delay = parseInt(this.dataset.tooltipDelay || '0', 10) * 1000;
    this.tooltipTimer = setTimeout(() => {
      this.tooltip.hidden = false;
    }, delay);
  }

  hideTooltip(persist) {
    clearTimeout(this.tooltipTimer);
    if (!this.tooltip) return;

    this.tooltip.hidden = true;
    if (persist) this.writeStorage(String(Date.now()));
  }

  readStorage() {
    try {
      return window.localStorage.getItem(this.dataset.storageKey);
    } catch (error) {
      return null;
    }
  }

  writeStorage(value) {
    try {
      window.localStorage.setItem(this.dataset.storageKey, value);
    } catch (error) {
      /* modo privado / storage bloqueado */
    }
  }

  /* ---------- Estado de atención ---------- */

  renderStatus() {
    if (!this.statusEl) return;

    const online = this.isOpenNow();
    const label = online ? this.statusEl.dataset.online : this.statusEl.dataset.offline;

    this.statusEl.hidden = false;
    this.statusEl.classList.toggle('is-online', online);

    const textNode = this.statusEl.querySelector('[data-wa-status-text]');
    if (textNode) textNode.textContent = label || '';

    if (!this.statusTimer) {
      this.statusTimer = setInterval(() => this.renderStatus(), 60000);
    }
  }

  isOpenNow() {
    const offset = parseFloat(this.dataset.utcOffset || '0');
    const now = new Date();
    const shopTime = new Date(now.getTime() + (offset * 60 + now.getTimezoneOffset()) * 60000);
    const day = shopTime.getDay();

    let raw = this.dataset.scheduleWeekdays;
    if (day === 0) raw = this.dataset.scheduleSunday;
    if (day === 6) raw = this.dataset.scheduleSaturday;

    const range = WhatsappFloat.parseRange(raw);
    if (!range) return false;

    const minutes = shopTime.getHours() * 60 + shopTime.getMinutes();
    return minutes >= range[0] && minutes < range[1];
  }

  static parseRange(value) {
    const match = /^\s*(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\s*$/.exec(value || '');
    if (!match) return null;

    return [
      Number(match[1]) * 60 + Number(match[2]),
      Number(match[3]) * 60 + Number(match[4]),
    ];
  }

  /* ---------- Analítica ---------- */

  trackAgent(node) {
    const detail = {
      agent: node.dataset.agent || '',
      channel: node.dataset.channel || 'whatsapp',
      phone: node.dataset.phone || '',
    };

    this.dispatchEvent(new CustomEvent('whatsapp-float:click', { bubbles: true, detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'contact_channel_click', ...detail });
    }
  }

  /* ---------- Theme Editor ---------- */

  initDesignMode() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    const id = this.dataset.sectionId;

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === id) this.open();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === id) this.close();
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (this.contains(event.target)) this.open();
    });
  }
}

if (!customElements.get('whatsapp-float')) {
  customElements.define('whatsapp-float', WhatsappFloat);
}
